import React, { useState } from 'react';
import useSearchFormHandlers from './SearchFormHandlers';
import { toast } from '../../Common/Toast';

const ProfileIdSearch = ({ isAdvanced }) => {
    const [inputValue, setInputValue] = useState('');
    const {
      searchByKeyword
    } = useSearchFormHandlers();

    const handleSearch = async () => {
      try {
        if (!inputValue.trim()) {
          toast.error('Please enter at least one character');
          return;
        }
        await searchByKeyword(inputValue);
      } catch (error) {
        toast.error('Search failed. Please try again.');
      }
    };

    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        handleSearch();
      }
    };

    return (
      <div className="basic-search-part">
        <div className="search-box">
          <div className="d-flex align-items-center justify-content-center">
            <input 
              type="text" 
              className="form-control me-2" 
              placeholder="Search profiles"
              style={{maxWidth: '250px'}}
              name={isAdvanced ? "advanceProfileId" : "profileId"}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button 
              className="btn custom-btn"
              onClick={handleSearch}
            >
              Go
            </button>
          </div>
        </div>
      </div>
    );
};

export default ProfileIdSearch;